import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, GovernmentProjectsReducer, GovernmentProjectsState, initialState } from './government-projects-reducer';

const GovernmentProjectsContext = createContext<GovernmentProjectsState | undefined>(undefined);
const GovernmentProjectsDispatchContext = createContext({} as any);

const GovernmentProjectsProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(GovernmentProjectsReducer, initialState);

    return (
        <GovernmentProjectsContext.Provider value={state}>
            <GovernmentProjectsDispatchContext.Provider value={dispatch}>
                {children}
            </GovernmentProjectsDispatchContext.Provider>
        </GovernmentProjectsContext.Provider>
    );
};

const useGovernmentProjectsState = () => {
    const context = useContext(GovernmentProjectsContext);
    if (context === undefined) {
        throw new Error('useGovernmentProjectsState must be used within a GovernmentProjectsProvider');
    }
    return context;
};

const useGovernmentProjectsDispatch = () => {
    const context = useContext(GovernmentProjectsDispatchContext);
    if (context === undefined) {
        throw new Error('useGovernmentProjectsDispatch must be used within a GovernmentProjectsProvider');
    }
    return context;
};

export { GovernmentProjectsProvider, useGovernmentProjectsState, useGovernmentProjectsDispatch, ACTION_TYPES };
